import React, {  useState,useEffect} from "react";
import { Grid, CircularProgress,Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import Post from './Post/Post';
import useStyles from './styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import { AppBar, Typography } from '@material-ui/core';
import Toolbar from "@material-ui/core/Toolbar";


const Posts = ({ setCurrentId }) => {
  const fuzzySearch = (list, searchValue) => {
    let buf = ".*" + searchValue.replace(/(.)/g, "$1.*").toLowerCase();
    var reg = new RegExp(buf);
    let newList = list.filter(function (e) {
      return reg.test(e.message||e.title.toLowerCase()||e.tags);
    });
    return newList;
  };
  const [searchValue, setSearchValue] = useState("");

  const posts = useSelector((state) => state.posts);
  const classes = useStyles();
   const [pageNumber, setPageNumber] = useState(1);
  const [buttonnext, setbuttonnext] = useState(false);
  const [prebutton, setprebutton] = useState(true);
  
    const limit=8;
  const [startIndex,setstartIndex] = useState();
  const [endIndex,setendIndex] = useState();

  useEffect(()=>{
    setstartIndex((pageNumber-1)*limit)
    setendIndex(pageNumber*limit)
    console.log(startIndex)
    console.log(endIndex)

  },[posts,pageNumber])

  const Next = ()=>{

    if(pageNumber === (Math.floor((posts.length+limit -1)/limit))){
     setbuttonnext(true)
     
    }else{
      setPageNumber(pageNumber+1)
      setprebutton(false)
    }
  }
  const Previous = () =>{
  
    if(pageNumber === 1){
      setprebutton(true)
    }else{
      setPageNumber(pageNumber-1)
      setbuttonnext(false)
    }
  }
  


  return(

    !posts.length ? <CircularProgress /> : <>
    <div className={classes.root}>
    <AppBar color="transparent" position="static" className={classes.appBar}  >
    <Toolbar>
    <Typography className={classes.title} variant="h6" noWrap>
קבוצות אחרונות 
</Typography>

       <Paper component="form" className={classes.search}>
     <IconButton className={classes.iconButton} aria-label="menu">
     </IconButton>
     <InputBase
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
       placeholder="חיפוש "
       inputProps={{ 'aria-label': 'search ' }}
       value={searchValue}
       onChange={(e) => setSearchValue(e.target.value)}
 
     />
     <IconButton  className={classes.searchIcon} aria-label="search">
       <SearchIcon />
     </IconButton>
     <Divider className={classes.divider} orientation="vertical" />
   </Paper>
   </Toolbar>

   </AppBar>

   <ol>
   <Grid container spacing={3}>

     {fuzzySearch(posts, searchValue).slice(startIndex,endIndex).map((d) =>  (
<Grid key={d._id} item xs={10} sm={4} md={3} spacing={7}>

<Post post={d} setCurrentId={setCurrentId} />
</Grid>)      )}
</Grid>
   </ol>
 </div>
    <Grid className={classes.container} container alignItems="stretch" spacing={3}>

<Grid container direction="row-reverse"justifyContent="center"alignItems="flex-end" >

<>
                    <button className={classes.button} onClick={Next}>הבא</button>
                    &nbsp;
                    <p className={classes.numText}>{ pageNumber}</p>
                    &nbsp;
                    <Button className={classes.button} onClick={Previous}>אחורה</Button>
                    </>
                    </Grid>                   

              </Grid></>
  )
};
export default Posts;